<template>
    <section id="cadeaux" class="Gifts">
      <div class="Gifts__head">
        <h2 class="Gifts__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Vos cadeaux Hortense</h2>
        <p class="Gifts__lead" :class="isPhone? 'merriweather-light-15' : 'merriweather-light-25'">
          Récompense unique pour vos collaborateurs de la part d’Hortense
        </p>
      </div>
  
      <div class="Gifts__grid">
        <article class="Gift">
          <div class="Gift__media">
            <img :src="imgTote" alt="Tote bag Hortense" loading="lazy" />
          </div>
          <h3 class="Gift__k raleway-bold-p16">UN TOTE BAG</h3>
          <p class="Gift__v raleway-reg-p15">En coton biologique certifié GOTS.</p>
        </article>
  
        <article class="Gift">
          <div class="Gift__media">
            <img :src="imgBook" alt="Livret d’inspiration" loading="lazy" />
          </div>
          <h3 class="Gift__k raleway-bold-p16">UN LIVRET D'INSPIRATION</h3>
          <p class="Gift__v raleway-reg-p15">Adresses, idées de séjours, conseils pour voyager autrement.</p>
        </article>
  
        <article class="Gift">
          <div class="Gift__media Gift__media--cover">
            <img :src="imgCard" alt="Carte cadeau Hortense" loading="lazy" />
          </div>
          <h3 class="Gift__k raleway-bold-p16">CARTE CADEAU HORTENSE</h3>
          <p class="Gift__v raleway-reg-p15">
            100€ valable 1 an, à utiliser sur notre plateforme, pour un séjour de 3 nuits minimum dans une sélection
            exclusive d'hébergements éco-responsables.
          </p>
        </article>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'GiftsHortense',
    data () {
      return {
        imgTote: require('../../images/Tote-bag-coffret-cadeaux-hortense.webp'),
        imgBook: require('../../images/Guide-voyage-hortense.webp'),
        imgCard: require('../../images/Carte-cadeaux-hortense.webp'),
        isPhone: window.innerWidth < 768
      }
    }
  }
  </script>
  
  <style scoped>
  .Gifts{
    max-width: 1200px;
    margin: 0 auto;
    padding: clamp(28px, 7vw, 72px) clamp(12px, 4vw, 24px);
  }
  .Gifts__head{
    text-align: center;
    margin-bottom: clamp(18px, 4vw, 32px);
  }
  .Gifts__title{
    margin: 0 0 clamp(10px, 1.8vw, 14px);
    text-align: center;
    margin: 0 0 clamp(18px, 3vw, 28px);
  }
  .Gifts__lead{
    color:#333;
    margin: 0;
  }
  
  .Gifts__grid{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(16px, 2.4vw, 28px);
    align-items: start;
  }
  
  .Gift__media{
    background:#f6f6f6;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 12px;
  }
  /* .Gift__media--cover{ aspect-ratio: 4 / 3; } */
  .Gift__media img{ width:100%; height:100%; object-fit:cover; display:block; }
  
  .Gift__k{
    letter-spacing: .2px;
    margin: 4px 0 6px;
  }
  .Gift__v{
    color:#333;;
    line-height: 1.55;
    margin: 0;
  }
  
  /* Responsive */
  @media (max-width: 1024px){
    .Gifts__grid{ grid-template-columns: 1fr 1fr; }
  }
  @media (max-width: 640px){
    .Gifts__grid{ grid-template-columns: 1fr; }
    .Gift__media{ aspect-ratio: 16 / 11; }
  }
  </style>
  